<template>
	<table-paginator :data="products" @pagechange="$emit('pagechange', $event)">
		<table class="customTable table table-hover">
			<tr>
				<th>Descrição</th>
				<th>Marca</th>
				<th v-if="!enabledPolicePrice">Preço</th>
				<th v-if="enabledPolicePrice">Preço à Prazo</th>
				<th v-if="enabledPolicePrice">Preço à Vista</th>
				<th v-if="enabledStock">Estoque</th>
        <th v-if="enabledStock">Estoque Minimo</th>
			</tr>
			<tbody>
				<tr
					v-for="row in products.data"
					@click="$emit('storeProduct', row.id)"
					:key="row.id"
				>
					<td style="cursor:pointer">
						{{ row.description }}
						<small class="text-muted"> #{{ row.base_sku_id }}</small>
					</td>
					<td style="cursor:pointer">{{ row.brand }}</td>
					<td v-if="!enabledPolicePrice" style="cursor:pointer">
						{{ row.product_variant[0].price | decimal }}
					</td>
					<td v-if="enabledPolicePrice" style="cursor:pointer">
						{{ row.product_variant[0].price_payment_on_terms | decimal }}
					</td>
					<td v-if="enabledPolicePrice" style="cursor:pointer">
						{{ row.product_variant[0].price_payment_immediate | decimal }}
					</td>
					<td v-if="enabledStock" style="cursor:pointer">
						{{
							row.product_variant[0].product_company[0].fisic_stock | decimal(3)
						}}
					</td>
          	<td v-if="enabledStock" style="cursor:pointer">
						{{
							row.product_variant[0].product_company[0].minimum_stock | decimal(3)
						}}
					</td>
				</tr>
			</tbody>
		</table>
	</table-paginator>
</template>

<script>
	import TablePaginator from "../../sections/TablePaginator";
	export default {
		components: {
			TablePaginator
		},

		props: {
			products: {}
		},

		computed: {
			enabledStock() {
				if (this.$store.state.company.module_stock_active == 1) {
					return true;
				}
			},

			enabledPolicePrice() {
				if (this.$store.state.company.product_payment_policy == 2) {
					return true;
				}
			}
		}
	};
</script>

<style>
</style>
